import "./App.scss";
import "./App.css";

// react router v6
import {
  Navigate,
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";

import { fetchUserData } from "./store/authSlice";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// , useLocation
// pages
import {
  Home,
  CategoryProduct,
  ProductSingle,
  Cart,
  Search,
  Favorite,
  VendorProducts,
  ProductSinglePages,
  ProductSingleCategoryPages,
} from "./pages/index";
// components
import Header from "./components/Header/Header";
import Sidebar from "./components/Sidebar/Sidebar";
import Footer from "./components/Footer/Footer";
import store from "./store/store";
import { Provider } from "react-redux";
import Login from "./pages/Login/Login";
import OtpForm from "./pages/Otp/Otp";
import Logout from "./pages/logout/Logout";
import Seller from "./pages/Seller";
import AllProducts from "./pages/AllProducts/AllProducts";
import UserProfile from "./pages/User/UserProfile";
import Contact from "./pages/Extra/Contact";
import { generateToken, messaging } from "./Firebase";
import { onMessage } from "firebase/messaging";
import toast, { Toaster } from "react-hot-toast";

function App() {
  useEffect(() => {
    generateToken();
  
    onMessage(messaging, (payload) => {
      // console.log("Notification reçue au premier plan :", payload);
  
      if (payload.notification) {
        const { title, body } = payload.notification;
        console.log("Titre :", title);
        console.log("Corps :", body);
        toast.success(body || "Notification reçue");
      } else {
        console.log("Structure inattendue :", payload);
      }
    });
  }, []);
  

  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      dispatch(fetchUserData(token)); // Récupérer les données utilisateur
    }
  }, [dispatch]);

  const NotFoundRedirect = () => {
    const navigate = useNavigate();

    useEffect(() => {
      navigate("/home"); // Redirige vers la page d'accueil
    }, [navigate]);

    return null; // Rien à afficher pendant la redirection
  };

  const isAuthenticated = !!user;

  return (
    <div className="App">
      <Provider store={store}>
        <Toaster position="top-right" />

        <Router>
          {
            //  showHeader &&
            <Header />
          }
          <Sidebar />

          <Routes>
            {/* home page route */}
            <Route path="/" element={<Home />} />
            {/* single product route */}
            <Route path="/product/:id" element={<ProductSingle />} />
            <Route
              path="/vendor/product/:id"
              element={<ProductSinglePages />}
            />
            <Route
              path="/vendor/category/:id"
              element={<ProductSingleCategoryPages />}
            />
            {/* category wise product listing route */}
            <Route path="/category/:category" element={<CategoryProduct />} />
            {/* vendor wise product listing route */}
            <Route path="/vendor/:id" element={<VendorProducts />} />
            {/* cart */}
            <Route path="/cart" element={<Cart />} />
            {/* cart */}
            <Route path="/favorite" element={<Favorite />} />
            {/* searched products */}
            <Route path="/search/:searchTerm" element={<Search />} />
            {/* Register */}
            <Route
              path="/login"
              element={isAuthenticated ? <Navigate to="/" /> : <Login />}
            />
            <Route
              path="/otp"
              element={isAuthenticated ? <Navigate to="/" /> : <OtpForm />}
            />
            {/* Login */}
            {/* <Route path = "/register" element = {<Register />} /> */}
            {/* Logout */}
            <Route path="/logout" element={<Logout />} />
            {/* Seller */}
            <Route path="/seller" element={<Seller />} />
            {/* <Route path="/profile" element={<Profile />} /> */}
            {/* Profile */}
            <Route path="/allproducts" element={<AllProducts />} />
            {/* Profile */}
            <Route
              path="/user/:activepage"
              element={
                isAuthenticated ? <UserProfile /> : <Navigate to="/login" />
              }
            />{" "}
            <Route path="/contact" element={<Contact />} />
            <Route path="/" element={<Navigate to="/" />} />
            <Route path="*" element={<Navigate to="/" />} />
            <Route path="*" element={<NotFoundRedirect />} />
          </Routes>

          <Footer />
        </Router>
      </Provider>
    </div>
  );
}

export default App;
